module.exports = __webpack_public_path__ + "static/img/davis_pictgrid40_960x881.4f53811.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid40_960x881.jpg
// module id = IDjw
// module chunks = 0